/* Sleep example usage:
async function demo() {
  // Taking a break
  await sleep(2000);
  // two seconds later ...
}
*/
export function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
